var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "videoContent" }, [
    _c("div", { staticClass: "swiper-box" }, [
      _c("div", { staticClass: "bswiper" }, [
        _c("div", { staticClass: "thumbs-box" }, [
          _c("div", { attrs: { id: "thumbs" } }, [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              _vm._l(_vm.swiper_img, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "swiper-slide",
                    class:
                      _vm.activeIndex === index
                        ? "swiper-slide-thumb-active"
                        : "",
                  },
                  [
                    _c("img", { attrs: { src: item.pic, alt: "" } }),
                    _c("p", { staticStyle: { "font-size": "12px" } }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
        _vm._m(0),
        _c("div", { staticClass: "right-swiper-box" }, [
          _c(
            "div",
            { staticClass: "swiper-container swiper-container-video" },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.swiper_img, function (item, i) {
                  return _c("div", { key: i, staticClass: "swiper-slide" }, [
                    _vm.activeIndex === i
                      ? _c("iframe", {
                          staticClass: "videobox",
                          attrs: { src: item.videoUrl, frameborder: "0" },
                        })
                      : _vm._e(),
                  ])
                }),
                0
              ),
            ]
          ),
          _c("div", { staticClass: "swiper-button-prev swiper-button-prev_1" }),
          _c("div", { staticClass: "swiper-button-next swiper-button-next_1" }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center-line" }, [
      _c("div", { staticClass: "light-line" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }